import { lazy } from "react";
import AddBank from "./Bank/AddBank";
import BankLists from "./Bank/BankLists";
import EditBank from "./Bank/EditBank";
import LimitBalance from "./Credit Settings/LimitBalance";
import Markup from "./MarkUp/Markup";
import NotificationSettings from "./Notification/NotificationSettings";
import AddReq from "./Payments/AddReq";
import AllReq from "./Payments/AllReq";
import ApprovedReq from "./Payments/ApprovedReq";
import CreditTransactionHistory from "./Payments/CreditTransactionHistory";
import DeclinedReq from "./Payments/DeclinedReq";
import ManualCRDR from "./Payments/ManualCRDR";
import PendingReq from "./Payments/PendingReq";
import AccountingQueues from "./Queues/AccountingQueues";
import BusBooking from "./Queues/BusBooking";
import CabQueues from "./Queues/CabQueues";
import FlightBookingQueues from "./Queues/FlightBookingQueues";
import FlightCancellationQueues from "./Queues/FlightCancellationQueues";
import FlightHoldQueues from "./Queues/FlightHoldQueues";
import FlightRescheduleQueues from "./Queues/FlightRescheduleQueues";
import HotelBooking from "./Queues/HotelBooking";
import HotelCancellation from "./Queues/HotelCancellation";
import HotelOnRequest from "./Queues/HotelOnRequest";
import ImportPNR from "./Queues/ImportPNR";
import LccPNR from "./Queues/LccPNR";
import OfflineEstimation from "./Queues/OfflineEstimation";
import OfflineRequest from "./Queues/OfflineRequest";
import PackageBooking from "./Queues/PackageBooking";
import PackageCancellation from "./Queues/PackageCancellation";
import QueuesManagement from "./Queues/QueuesManagement";
import ReassignQueues from "./Queues/ReassignQueues";
import ToBeTicketQueues from "./Queues/ToBeTicketQueues";
import TourCancellation from "./Queues/TourCancellation";
import TrainBooking from "./Queues/TrainBooking";
import TripQueues from "./Queues/TripQueues";
import UpdatePnr from "./Queues/UpdatePnr";
import TransactionHistory from "./Transaction-history/TransactionHistory";

import AddAgentStaff from "./Users/AddAgentStaff";
import AddSubAgent from "./Users/AddSubAgent";

import PendingRequest from "./Users/PendingRequest";

import ViewAllUsers from "./Users/ViewAllUsers";

import SecurityBalance from "./Credit Settings/SecurityBalance";
import BookingHistory from "./Flight/Booking";
import CreditOpeningClosing from "./Payments/CreditOpeningClosing";

import AddCharter from "./Flight/Add";
import CharterFlightList from "./Flight/List";
import CreditBalanceSettlement from "./Payments/CreditBalanceSettlement";

import VirtualBankList from "./Bank/VirtualBankList";
import CreditLimit from "./Payments/CreditLimit";
import ApplicationSettings from "./SystemSetting/ApplicationSettings";
import BannerSetting from "./SystemSetting/BannerSetting";
import Services from "./SystemSetting/SystemSettings";

import ChangeRequest from "./Flight/ChangeRequest";

import Roles from "./Users/Roles Folder/Roles";

import Menu from "./Users/MenuFolder/Menu";
import Permission from "./Users/Permission Folder/Permission";
import AddUser from "./Users/User Folder/AddUser";
import Users from "./Users/User Folder/Users";

import CreditList from "./Credit/CreditList";
import CreditSettlement from "./Credit/CreditSettle";
import Dashboard from "./Dashboard/Dashboard";
import MemberCreditDebitList from "./Payments/MemberCreditDebit";
import AddSupplier from "./Supplier/AddSupplier";
import EditSupplier from "./Supplier/EditSupplier";
// import SupplierList from "./Supplier/SupplierList";
import EditUser from "./Users/User Folder/EditUSer";

import AddApi from "./Api Vendor/AddApi";
import AirlinesMasterList from "./Flight/AirlinesMasterList";
import AirportsList from "./Flight/AirportsList";
import CancellationList from "./Flight/CancellationList";
import CancelRequest from "./Flight/CancelRequest";
import HotelMarkup from "./Hotel/hotelMarkup";
import AddTicket from "./OfflineTicket/AddTicket";
// import VendorList from "./Api Vendor/VendorList";
import SupplierAirlinesList from "./SupplierSetting/SupplierAirlinesList";
import SupplierCommissionList from "./SupplierSetting/SupplierCommissionList";
import SupplierList from "./SupplierSetting/SupplierList";
import GroupTagging from "./SystemSetting/GroupTagging";
import LogoUpload from "./SystemSetting/LogoUpload";
import IpVendorList from "./ip-vendor/IpList";
import AddIpVendor from "./ip-vendor/AddIpVendor";
import EditIpVendor from "./ip-vendor/EditIpVendor";
// import BookingDetails from "./Flight/BookingDetails/BookingDetails";

const DistributorList = lazy(() => import("./Distributor/DistributorList"));
const AddDistributor = lazy(() => import("./Distributor/AddDistributor"));
const EditDistributor = lazy(() => import("./Distributor/EditDistributor"));
const DeleteDistributor = lazy(() => import("./Distributor/DeleteDistributor"));
const MerchantList = lazy(() => import("./Merchant/MerchantList"));
const RequestedMerchants = lazy(() => import("./Merchant/RequestedMerchants"));
const AddMerchant = lazy(() => import("./Merchant/AddMerchant"));
const EditMerchant = lazy(() => import("./Merchant/EditMerchant"));
const EditBookingDetails = lazy(() =>
  import("./Flight/BookingDetails/BookingDetails")
);
const UserGroup = lazy(() => import("./UserGroup/UserGroup"));
const TicketBookingDetails = lazy(() =>
  import("./Flight/BookingDetails/TicketDetails")
);
const adminRoutes = [
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
  },

  {
    path: "/admin/distributors",
    element: <DistributorList />,
  },
  {
    path: "/admin/distributor/add",
    element: <AddDistributor />,
  },
  {
    path: "/admin/distributor/edit/:memId",
    element: <EditDistributor />,
  },
  {
    path: "/admin/distributor/delete/:memId",
    element: <DeleteDistributor />,
  },
  {
    path: "/admin/api-partner",
    element: <MerchantList />,
  },

  {
    path: "/admin/member-notification",
    element: <NotificationSettings />,
  },
  {
    path: "/admin/requested-api-partner",
    element: <RequestedMerchants />,
  },

  // {
  //   path: "/admin/supplier-list",
  //   element: <SupplierList />,
  // },
  {
    path: "/admin/supplier/add",
    element: <AddSupplier />,
  },
  {
    path: "/admin/supplier/edit/:memId",
    element: <EditSupplier />,
  },

  {
    path: "/admin/api-partner/add",
    element: <AddMerchant />,
  },
  {
    path: "/admin/api-partner/edit/:memId",
    element: <EditMerchant />,
  },
  {
    path: "/admin/markup",
    element: <Markup />,
  },
  {
    path: "/admin/hotel/markup",
    element: <HotelMarkup />,
  },
  {
    path: "/admin/user-group",
    element: <UserGroup />,
  },
  {
    path: "/admin/bank/bank-lists",
    element: <BankLists />,
  },
  {
    path: "/admin/bank/add",
    element: <AddBank />,
  },
  {
    path: "/transaction-history",
    element: <TransactionHistory />,
  },

  {
    path: "/admin/credit/limit-balance",
    element: <LimitBalance />,
  },
  {
    path: "/admin/credit/security-balance",
    element: <SecurityBalance />,
  },

  {
    path: "/admin/users/viewAllUsers",
    element: <ViewAllUsers />,
  },
  {
    path: "/admin/bank/editBank",
    element: <EditBank />,
  },
  {
    path: "/admin/users/addAgencyStaff",
    element: <AddAgentStaff />,
  },
  {
    path: "/admin/users/addSubagent",
    element: <AddSubAgent />,
  },
  {
    path: "/admin/users/roles",
    element: <Roles />,
  },
  {
    path: "/admin/users/users",
    element: <Users />,
  },
  {
    path: "/admin/users/add",
    element: <AddUser />,
  },
  {
    path: "/admin/users/edit",
    element: <EditUser />,
  },
  {
    path: "/admin/credit-settle",
    element: <CreditSettlement />,
  },

  {
    path: "/admin/credit-list",
    element: <CreditList />,
  },
  {
    path: "/admin/users/permission",
    element: <Permission />,
  },
  {
    path: "/admin/users/menu",
    element: <Menu />,
  },

  {
    path: "/admin/users/pendingRequest",
    element: <PendingRequest />,
  },
  {
    path: "/admin/payment/creditTransaction",
    element: <CreditTransactionHistory />,
  },
  {
    path: "/admin/payment/credit-opening-closing",
    element: <CreditOpeningClosing />,
  },
  {
    path: "/admin/payment/credit-report",
    element: <CreditLimit />,
  },
  {
    path: "/admin/payments/credit-balance-settlement",
    element: <CreditBalanceSettlement />,
  },

  {
    path: "/admin/queues/accountingQueues",
    element: <AccountingQueues />,
  },
  {
    path: "/admin/queues/importPnr",
    element: <ImportPNR />,
  },
  {
    path: "/admin/queues/lccPnr",
    element: <LccPNR />,
  },
  {
    path: "/admin/queues/queuesManagement",
    element: <QueuesManagement />,
  },
  {
    path: "/admin/queues/reassignQueues",
    element: <ReassignQueues />,
  },
  {
    path: "/admin/queues/flightBookingQueues",
    element: <FlightBookingQueues />,
  },
  {
    path: "/admin/queues/offlineRequest",
    element: <OfflineRequest />,
  },
  {
    path: "/admin/queues/toBeTicketQueues",
    element: <ToBeTicketQueues />,
  },
  {
    path: "/admin/queues/offlineEstimation",
    element: <OfflineEstimation />,
  },
  {
    path: "/admin/queues/tripQueues",
    element: <TripQueues />,
  },
  {
    path: "/admin/queues/flightCancellationQueues",
    element: <FlightCancellationQueues />,
  },
  {
    path: "/admin/queues/flightRescheduleQueues",
    element: <FlightRescheduleQueues />,
  },
  {
    path: "/admin/queues/flightHoldQueues",
    element: <FlightHoldQueues />,
  },
  {
    path: "/admin/queues/busBooking",
    element: <BusBooking />,
  },
  {
    path: "/admin/queues/trainBooking",
    element: <TrainBooking />,
  },
  {
    path: "/admin/queues/cabQueues",
    element: <CabQueues />,
  },
  {
    path: "/admin/queues/hotelBooking",
    element: <HotelBooking />,
  },
  {
    path: "/admin/queues/hotelOnRequest",
    element: <HotelOnRequest />,
  },
  {
    path: "/admin/queues/hotelCancellation",
    element: <HotelCancellation />,
  },
  {
    path: "/admin/queues/packageBooking",
    element: <PackageBooking />,
  },
  {
    path: "/admin/queues/packageCancellation",
    element: <PackageCancellation />,
  },
  {
    path: "/admin/queues/updatePnr",
    element: <UpdatePnr />,
  },
  {
    path: "/admin/queues/tourCancellation",
    element: <TourCancellation />,
  },

  {
    path: "/admin/payments/all-req",
    element: <AllReq />,
  },
  {
    path: "/admin/payments/pending-req",
    element: <PendingReq />,
  },
  {
    path: "/admin/payments/approved-req",
    element: <ApprovedReq />,
  },
  {
    path: "/admin/payments/declined-req",
    element: <DeclinedReq />,
  },
  {
    path: "/admin/payments/manual-cr-dr",
    element: <ManualCRDR />,
  },
  {
    path: "/admin/payments/add-req",
    element: <AddReq />,
  },

  {
    path: "/admin/member-credit-debit-list",
    element: <MemberCreditDebitList />,
  },

  {
    path: "/admin/flight/list",
    element: <CharterFlightList />,
  },
  {
    path: "/admin/flight/add",
    element: <AddCharter />,
  },
  {
    path: "/admin/flight/change-request",
    element: <ChangeRequest />,
  },
  {
    path: "/admin/flight/booking-history",
    element: <BookingHistory />,
  },
  {
    path: "/admin/settings/offer-banner-setting",
    element: <BannerSetting />,
  },
  {
    path: "/admin/settings/application-setting",
    element: <ApplicationSettings />,
  },
  {
    path: "/admin/settings/services",
    element: <Services />,
  },
  {
    path: "/admin/account/virtual-bank-list",
    element: <VirtualBankList />,
  },

  {
    path: "/admin/flight/cancel-request",
    element: <CancelRequest />,
  },
  {
    path: "/admin/flight/airports-list",
    element: <AirportsList />,
  },
  {
    path: "/admin/flight/cancellation-list",
    element: <CancellationList />,
  },
  {
    path: "/admin/flight/airlines-list",
    element: <AirlinesMasterList />,
  },
  {
    path: "/admin/flight/booking-details/:id",
    element: <EditBookingDetails />,
  },
  {
    path: "/admin/offline/add",
    element: <AddTicket />,
  },
  {
    path: "/admin/api/add",
    element: <AddApi />,
  },
  // {
  //   path: "/admin/api-list",
  //   element: <VendorList />,
  // },
  {
    path: "/admin/flight/ticket/:id",
    element: <TicketBookingDetails />,
  },
  {
    path: "/admin/supplier/supplier-commission-list",
    element: <SupplierCommissionList />,
  },
  {
    path: "/admin/supplier/supplier-airlines-list",
    element: <SupplierAirlinesList />,
  },
  {
    path: "/admin/supplier/supplier-list",
    element: <SupplierList />,
  },
  {
    path: "/admin/supplier/group-tagged",
    element: <GroupTagging />,
  },
  // {
  //   path: "/admin/settings/login-otp-details",
  //   element: <OtpExpireSettings />,
  // },
  {
    path: "/admin/settings/company-logo-upload",
    element: <LogoUpload />,
  },
  {
    path: "/admin/ip-vendor",
    element: <IpVendorList />,
  },
  {
    path: "/admin/ip-vendor/add",
    element: <AddIpVendor />,
  },
  {
    path: "/admin/ip-vendor/edit/:id",
    element: <EditIpVendor />,
  },
];

export default adminRoutes;
